import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { Mapper } from "@/common/services/mapper";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

type UseEstablishmentMovementsTotalizerProps<T> = {
  filters: {
    id: string;
    startDate?: string;
    endDate?: string;
  },
  mapper?: (data: any) => T;
};

const useEstablishmentMovementsTotalizer = <T,>({ filters: { id, startDate, endDate }, mapper = Mapper.default<T>() }: UseEstablishmentMovementsTotalizerProps<T>) => {
  const privateAxios = usePrivateAxios()

  const { 
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest } = useQuery({
    queryKey: ['establishmentMovementsTotalizer', id, startDate, endDate],
    queryFn: () => {
      return privateAxios.get(`/establishment/companies/${id}/movements_totalizer`, {
        params: {
          "q[created_at_gteq]": startDate,
          "q[created_at_lteq]": endDate,
        },
      });
    },
    select: (data: { data: { data: any[], meta: MetaResponse; }; }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });
  return { data, meta, isPending, ...rest };
};

export default useEstablishmentMovementsTotalizer;
